export default {
  helpCenterLayoutTitle: {
    id: 'hc_navigation_help_center',
    defaultMessage: 'Help Center',
  },
}
